module.exports = __webpack_public_path__ + "static/media/QuizApp.89233e0e.jpg";